import type { SetupContext } from 'vue';
import type { PrintingScreenEvents } from './types';

export function usePrintingController(
  emit: SetupContext<PrintingScreenEvents>['emit']
) {
  return {
    help: () => emit('help'),
  };
}
